/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetIntakeCallTemplatesResponseDto } from '../models';
// @ts-ignore
import type { IntakeCallTemplateDto } from '../models';
// @ts-ignore
import type { IntakeCallTemplateSortByDto } from '../models';
// @ts-ignore
import type { SaveIntakeCallTemplateRequestDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
/**
 * IntakeCallTemplatesRestApi - axios parameter creator
 */
export const IntakeCallTemplatesRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add an intake call template to the library
         * @param {SaveIntakeCallTemplateRequestDto} saveIntakeCallTemplateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntakeCallTemplate: async (saveIntakeCallTemplateRequestDto: SaveIntakeCallTemplateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveIntakeCallTemplateRequestDto' is not null or undefined
            assertParamExists('createIntakeCallTemplate', 'saveIntakeCallTemplateRequestDto', saveIntakeCallTemplateRequestDto)
            const localVarPath = `/api/v1/intake-call-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveIntakeCallTemplateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Processes keep the intake call they copied from the template.
         * @summary Remove a template from the library
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIntakeCallTemplate: async (templateId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deleteIntakeCallTemplate', 'templateId', templateId)
            const localVarPath = `/api/v1/intake-call-templates/{templateId}`
                .replace('{templateId}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get one intake call template
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntakeCallTemplate: async (templateId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getIntakeCallTemplate', 'templateId', templateId)
            const localVarPath = `/api/v1/intake-call-templates/{templateId}`
                .replace('{templateId}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Everyone can browse the templates and load one into a process; only the author or an administrator can update or delete a template. The phrase is matched case-insensitively against the name and the content. Default sort is updatedAt desc. 
         * @summary Search the shared intake call template library
         * @param {string} [phrase] Case-insensitive phrase matched against the template name and content.
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {IntakeCallTemplateSortByDto} [sortBy] 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntakeCallTemplates: async (phrase?: string, page?: number, pageSize?: number, sortBy?: IntakeCallTemplateSortByDto, sortOrder?: SortDirectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/intake-call-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (phrase !== undefined) {
                localVarQueryParameter['phrase'] = phrase;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Processes that took their intake call from this template keep their own copy, so the change does not reach them. 
         * @summary Change the name and content of a template
         * @param {number} templateId 
         * @param {SaveIntakeCallTemplateRequestDto} saveIntakeCallTemplateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIntakeCallTemplate: async (templateId: number, saveIntakeCallTemplateRequestDto: SaveIntakeCallTemplateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateIntakeCallTemplate', 'templateId', templateId)
            // verify required parameter 'saveIntakeCallTemplateRequestDto' is not null or undefined
            assertParamExists('updateIntakeCallTemplate', 'saveIntakeCallTemplateRequestDto', saveIntakeCallTemplateRequestDto)
            const localVarPath = `/api/v1/intake-call-templates/{templateId}`
                .replace('{templateId}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveIntakeCallTemplateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntakeCallTemplatesRestApi - functional programming interface
 */
export const IntakeCallTemplatesRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntakeCallTemplatesRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add an intake call template to the library
         * @param {SaveIntakeCallTemplateRequestDto} saveIntakeCallTemplateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIntakeCallTemplate(saveIntakeCallTemplateRequestDto: SaveIntakeCallTemplateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntakeCallTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIntakeCallTemplate(saveIntakeCallTemplateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeCallTemplatesRestApi.createIntakeCallTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Processes keep the intake call they copied from the template.
         * @summary Remove a template from the library
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteIntakeCallTemplate(templateId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteIntakeCallTemplate(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeCallTemplatesRestApi.deleteIntakeCallTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get one intake call template
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIntakeCallTemplate(templateId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntakeCallTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIntakeCallTemplate(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeCallTemplatesRestApi.getIntakeCallTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Everyone can browse the templates and load one into a process; only the author or an administrator can update or delete a template. The phrase is matched case-insensitively against the name and the content. Default sort is updatedAt desc. 
         * @summary Search the shared intake call template library
         * @param {string} [phrase] Case-insensitive phrase matched against the template name and content.
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {IntakeCallTemplateSortByDto} [sortBy] 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIntakeCallTemplates(phrase?: string, page?: number, pageSize?: number, sortBy?: IntakeCallTemplateSortByDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIntakeCallTemplatesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIntakeCallTemplates(phrase, page, pageSize, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeCallTemplatesRestApi.getIntakeCallTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Processes that took their intake call from this template keep their own copy, so the change does not reach them. 
         * @summary Change the name and content of a template
         * @param {number} templateId 
         * @param {SaveIntakeCallTemplateRequestDto} saveIntakeCallTemplateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIntakeCallTemplate(templateId: number, saveIntakeCallTemplateRequestDto: SaveIntakeCallTemplateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntakeCallTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIntakeCallTemplate(templateId, saveIntakeCallTemplateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeCallTemplatesRestApi.updateIntakeCallTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IntakeCallTemplatesRestApi - factory interface
 */
export const IntakeCallTemplatesRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntakeCallTemplatesRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Add an intake call template to the library
         * @param {SaveIntakeCallTemplateRequestDto} saveIntakeCallTemplateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntakeCallTemplate(saveIntakeCallTemplateRequestDto: SaveIntakeCallTemplateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<IntakeCallTemplateDto> {
            return localVarFp.createIntakeCallTemplate(saveIntakeCallTemplateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Processes keep the intake call they copied from the template.
         * @summary Remove a template from the library
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIntakeCallTemplate(templateId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteIntakeCallTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get one intake call template
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntakeCallTemplate(templateId: number, options?: RawAxiosRequestConfig): AxiosPromise<IntakeCallTemplateDto> {
            return localVarFp.getIntakeCallTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Everyone can browse the templates and load one into a process; only the author or an administrator can update or delete a template. The phrase is matched case-insensitively against the name and the content. Default sort is updatedAt desc. 
         * @summary Search the shared intake call template library
         * @param {string} [phrase] Case-insensitive phrase matched against the template name and content.
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {IntakeCallTemplateSortByDto} [sortBy] 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntakeCallTemplates(phrase?: string, page?: number, pageSize?: number, sortBy?: IntakeCallTemplateSortByDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig): AxiosPromise<GetIntakeCallTemplatesResponseDto> {
            return localVarFp.getIntakeCallTemplates(phrase, page, pageSize, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Processes that took their intake call from this template keep their own copy, so the change does not reach them. 
         * @summary Change the name and content of a template
         * @param {number} templateId 
         * @param {SaveIntakeCallTemplateRequestDto} saveIntakeCallTemplateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIntakeCallTemplate(templateId: number, saveIntakeCallTemplateRequestDto: SaveIntakeCallTemplateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<IntakeCallTemplateDto> {
            return localVarFp.updateIntakeCallTemplate(templateId, saveIntakeCallTemplateRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntakeCallTemplatesRestApi - interface
 */
export interface IntakeCallTemplatesRestApiInterface {
    /**
     * 
     * @summary Add an intake call template to the library
     * @param {SaveIntakeCallTemplateRequestDto} saveIntakeCallTemplateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createIntakeCallTemplate(saveIntakeCallTemplateRequestDto: SaveIntakeCallTemplateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<IntakeCallTemplateDto>;

    /**
     * Processes keep the intake call they copied from the template.
     * @summary Remove a template from the library
     * @param {number} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteIntakeCallTemplate(templateId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get one intake call template
     * @param {number} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIntakeCallTemplate(templateId: number, options?: RawAxiosRequestConfig): AxiosPromise<IntakeCallTemplateDto>;

    /**
     * Everyone can browse the templates and load one into a process; only the author or an administrator can update or delete a template. The phrase is matched case-insensitively against the name and the content. Default sort is updatedAt desc. 
     * @summary Search the shared intake call template library
     * @param {string} [phrase] Case-insensitive phrase matched against the template name and content.
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {IntakeCallTemplateSortByDto} [sortBy] 
     * @param {SortDirectionDto} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIntakeCallTemplates(phrase?: string, page?: number, pageSize?: number, sortBy?: IntakeCallTemplateSortByDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig): AxiosPromise<GetIntakeCallTemplatesResponseDto>;

    /**
     * Processes that took their intake call from this template keep their own copy, so the change does not reach them. 
     * @summary Change the name and content of a template
     * @param {number} templateId 
     * @param {SaveIntakeCallTemplateRequestDto} saveIntakeCallTemplateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIntakeCallTemplate(templateId: number, saveIntakeCallTemplateRequestDto: SaveIntakeCallTemplateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<IntakeCallTemplateDto>;

}

/**
 * IntakeCallTemplatesRestApi - object-oriented interface
 */
export class IntakeCallTemplatesRestApi extends BaseAPI implements IntakeCallTemplatesRestApiInterface {
    /**
     * 
     * @summary Add an intake call template to the library
     * @param {SaveIntakeCallTemplateRequestDto} saveIntakeCallTemplateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createIntakeCallTemplate(saveIntakeCallTemplateRequestDto: SaveIntakeCallTemplateRequestDto, options?: RawAxiosRequestConfig) {
        return IntakeCallTemplatesRestApiFp(this.configuration).createIntakeCallTemplate(saveIntakeCallTemplateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Processes keep the intake call they copied from the template.
     * @summary Remove a template from the library
     * @param {number} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteIntakeCallTemplate(templateId: number, options?: RawAxiosRequestConfig) {
        return IntakeCallTemplatesRestApiFp(this.configuration).deleteIntakeCallTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get one intake call template
     * @param {number} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getIntakeCallTemplate(templateId: number, options?: RawAxiosRequestConfig) {
        return IntakeCallTemplatesRestApiFp(this.configuration).getIntakeCallTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Everyone can browse the templates and load one into a process; only the author or an administrator can update or delete a template. The phrase is matched case-insensitively against the name and the content. Default sort is updatedAt desc. 
     * @summary Search the shared intake call template library
     * @param {string} [phrase] Case-insensitive phrase matched against the template name and content.
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {IntakeCallTemplateSortByDto} [sortBy] 
     * @param {SortDirectionDto} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getIntakeCallTemplates(phrase?: string, page?: number, pageSize?: number, sortBy?: IntakeCallTemplateSortByDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig) {
        return IntakeCallTemplatesRestApiFp(this.configuration).getIntakeCallTemplates(phrase, page, pageSize, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Processes that took their intake call from this template keep their own copy, so the change does not reach them. 
     * @summary Change the name and content of a template
     * @param {number} templateId 
     * @param {SaveIntakeCallTemplateRequestDto} saveIntakeCallTemplateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateIntakeCallTemplate(templateId: number, saveIntakeCallTemplateRequestDto: SaveIntakeCallTemplateRequestDto, options?: RawAxiosRequestConfig) {
        return IntakeCallTemplatesRestApiFp(this.configuration).updateIntakeCallTemplate(templateId, saveIntakeCallTemplateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

